const closeReasonList = [
    {value: 'Lost on Price', label: 'Lost on Price'},
    {value: 'Change in trip details', label: 'Change in trip details'},
    {value: 'Trip Cancelled', label: 'Trip Cancelled'},
    {value: 'Duplicate', label: 'Duplicate'},
    {value: 'Price is over budget', label: 'Price is over budget'},
    {value: 'Possible Ambassador', label: 'Possible Ambassador'},
    {value: 'Incorrect contact details', label: 'Incorrect contact details'},
    {value: 'Test', label: 'Test'},
    {value: 'The product does not meet customer expectations', label: 'The product does not meet customer expectations'},
    {value: 'Flew Commercial', label: 'Flew Commercial'},
    {value: 'No response from Client', label: 'No response from Client'},
    {value: 'Clients cannot afford Private Jet', label: 'Clients cannot afford Private Jet'},
    {value: 'Flight date in the past', label: 'Flight date in the past'},
    {value: 'Lack of expertise on part of broker', label: 'Lack of expertise on part of broker'},
    {value: 'Lost Aircraft', label: 'Lost Aircraft'},
    {value: 'Speed of response', label: 'Speed of response'},
    {value: 'Gone Technical (unable to replace)', label: 'Gone Technical (unable to replace)'},
    {value: 'Wrong Decision Maker', label: 'Wrong Decision Maker'},
    {value: 'Trip Postponed (allow broker to create a reminder to call client)', label: 'Trip Postponed (allow broker to create a reminder to call client)'},
    {value: 'System Error', label: 'System Error'},
    {value: 'Lost to Competitor', label: 'Lost to Competitor'}    
]

const kycHeatList = [
    {value: 'Hot', label: 'Hot'},
    {value: 'Medium', label: 'Medium'},
    {value: 'Speculative', label: 'Speculative'},
    {value: 'Redundant', label: 'Redundant'},
    {value: 'Duplicate', label: 'Duplicate'},
    {value: 'Staff', label: 'Staff'}
]

const wifiList = [
    {value: 'No WIFI Available', label: 'No WIFI Available'},
    {value: 'WIFI Available (Additional cost)', label: 'WIFI Available (Additional cost)'},
    {value: 'WIFI Included', label: 'WIFI Included'}
]

const cateringList = [
    {value: 'No Catering Included', label: 'No Catering Included'},
    {value: 'Snack Catering Included', label: 'Snack Catering Included'},
    {value: 'Light Catering Included', label: 'Light Catering Included'},
    {value: 'VIP Catering Included', label: 'VIP Catering Included'}
]

const dealSourceList = [
    {value: '3rd Party Referral', label: '3rd Party Referral'},
    {value: 'Ambassador Referral', label: 'Ambassador Referral'},
    {value: 'Chat AI', label: 'Chat AI'},
    {value: 'CommVersion', label: 'CommVersion'},
    {value: 'Desk Research / Mining', label: 'Desk Research / Mining'},
    {value: 'Employee Referral / Personal Contact', label: 'Employee Referral / Personal Contact'},
    {value: 'Enquiry to fly@SHY', label: 'Enquiry to fly@SHY'},
    {value: 'Existing Client', label: 'Existing Client'},
    {value: 'Existing Client Referral', label: 'Existing Client Referral'},
    {value: 'Giles / Scott Referral', label: 'Giles / Scott Referral'},
    {value: 'Instagram', label: 'Instagram'},
    {value: 'Lifestyle Referral', label: 'Lifestyle Referral'},
    {value: 'LinkedIn', label: 'LinkedIn'},
    {value: 'Marketing Campaign', label: 'Marketing Campaign'},
    {value: 'Other Referral', label: 'Other Referral'},
    {value: 'Search Engine', label: 'Search Engine'},
    {value: 'Test Only', label: 'Test Only'},
    {value: 'Trade Show / Networking Event', label: 'Trade Show / Networking Event'},
    {value: 'Twitter', label: 'Twitter'},
    {value: 'Website', label: 'Website'},
    {value: 'WhatsApp', label: 'WhatsApp'},
]

const yesNoList = [
    {value: 'No', label: 'No'},
    {value: 'Yes', label: 'Yes'}
]

const portalFilterOptions = [
    {value: 'all', label: 'All'},
    {value: 'Mine', label: 'My deals'},
    {value: 'Shy', label: 'SHY deals'},
    {value: 'Jetsphere', label: 'JetSphere deals'},
]

export {closeReasonList, kycHeatList, wifiList, cateringList, dealSourceList, yesNoList, portalFilterOptions}